// extracted by mini-css-extract-plugin
export var container = "_45-0";
export var disabled = "_45-4";
export var fullWidth = "_45-3";
export var lined = "_45-1";
export var selected = "_45-5";
export var tab = "_45-2";